import {
  alpha,
  Box,
  Container,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { Image01, Image02, Image03 } from "assets";
import theme, { responsiveFontSize } from "themes/Theme";
import CheckCircleIcon from "assets/svg/CheckCirleIcon";
import PrimaryButton from "components/PrimaryButton/PrimaryButton";
import { useNavigate } from "react-router-dom";

const OurBenefits = () => {
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();

  return (
    <Container sx={styles.benefitContainer}>
      <Box sx={styles.benefitContentContainer}>
        <Typography sx={styles.heading1}>
          Benefit of<span>carbon</span>plant
        </Typography>
        <Typography sx={styles.description}>
          Join a smarter way to support the planet while managing your digital
          assets
        </Typography>

        <List>
          <ListItem disablePadding>
            <ListItemIcon>
              <CheckCircleIcon />
            </ListItemIcon>
            <ListItemText sx={styles.listItemTextStyle}>
              Instant Emission Insights
            </ListItemText>
          </ListItem>
          <ListItem disablePadding>
            <ListItemIcon>
              <CheckCircleIcon />
            </ListItemIcon>
            <ListItemText sx={styles.listItemTextStyle}>
              Seamless ERC Management
            </ListItemText>
          </ListItem>
          <ListItem disablePadding>
            <ListItemIcon>
              <CheckCircleIcon />
            </ListItemIcon>
            <ListItemText sx={styles.listItemTextStyle}>
              Impact with Every Transaction
            </ListItemText>
          </ListItem>
        </List>

        <PrimaryButton
          viewStyle={{ marginTop: 3 }}
          title="Learn More"
          onClick={() => {
            navigate("/about-us");
          }}
        />
      </Box>
      {isMobile ? null : (
        <Box sx={styles.benefitImageContainer}>
          <Box sx={styles.image1}>
            <Typography sx={styles.imageTextStyle}>NFT</Typography>
          </Box>
          <Box sx={styles.image2}>
            <Typography sx={styles.imageTextStyle}>Fast</Typography>
          </Box>
          <Box sx={styles.image3}>
            <Typography sx={styles.imageTextStyle}>Secure</Typography>
          </Box>
        </Box>
      )}
    </Container>
  );
};
export default OurBenefits;
const styles = {
  benefitContainer: {
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    alignItems: "flex-start",
    py: 6,
    marginBottom: 8,
  },
  benefitContentContainer: {
    flex: 1,
  },
  benefitImageContainer: {
    flex: 2,
    position: "relative",
  },
  image1: {
    background: `url(${Image01})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    position: "absolute",
    right: 240,
    top: 0,
    borderRadius: "1.5rem",
    width: "20em",
    height: "12em",
  },
  image2: {
    background: `url(${Image02})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    position: "absolute",
    right: 0,
    top: 90,
    borderRadius: "1.5rem",
    width: "23em",
    height: "15em",
  },
  image3: {
    background: `url(${Image03})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    position: "absolute",
    right: 260,
    top: 240,
    borderRadius: "1.5rem",
    width: "14.625em",
    height: "10.438em",
  },
  heading3: {
    fontSize: "clamp(0.6rem, 3.4vw,0.75rem)",
    color: theme.palette.primary.main,
    fontWeight: 400,
  },
  heading1: {
    fontSize: responsiveFontSize(45),
    color: theme.palette.primary.main,
    fontWeight: 400,
    lineHeight: 1.2,
    marginTop: 2,
    marginBottom: 3,
    "& span": {
      backgroundColor: alpha(theme.palette.primary.light, 0.2),
      color: theme.palette.custom?.black,
      borderRadius: "3em",
      px: 2,
    },
  },
  description: {
    color: theme.palette.text.secondary,
    fontSize: "clamp(1rem, 4vw,1rem)",
    fontWeight: 400,
    marginTop: 2,
  },
  imageTextStyle: {
    backgroundColor: alpha(theme.palette.primary.main, 0.6),
    color: theme.palette.custom?.white,
    fontSize: "1rem",
    fontWeight: 400,
    width: "max-content",
    borderRadius: "1em",
    px: 1.5,
    py: 0.2,
    mt: 2,
    ml: 2,
  },
  listItemTextStyle: {
    fontSize: "clamp(0.7rem, 3vw, 0.875rem)",
    fontWeight: 400,
    color: theme.palette.text.secondary,
  },
};
